import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Hotel,
  Users,
  CalendarCheck,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Clock,
  AlertTriangle,
} from "lucide-react";
import { logout } from "../utils/auth";

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false); // 👈 new

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/hotels", label: "Hotels", icon: Hotel },
    { path: "/owner-listings", label: "Owner Listing", icon: Users },
    { path: "/customers", label: "Customers", icon: Users },
  ];

  const isActive = (path: string) => location.pathname === path;

  const handleLogoutConfirm = () => {
    logout();
    navigate("/login");
  };

  return (
    <>
      <aside
        className={`${isCollapsed ? "w-[72px]" : "w-64"
          } bg-brand-700 h-screen transition-all duration-300 flex flex-col`}
      >
        {/* Logo Header */}
        <div className={`flex items-center ${isCollapsed ? "justify-center" : "justify-between"} h-16 px-4 border-b border-brand-600/50`}>
          {!isCollapsed && (
            <div className="flex items-center gap-2.5">
                <img
        src="/La-La.png"
        alt="Logo"
        className="w-10 h-10 object-contain rounded-lg"
      />
             
              <span className="text-base font-bold text-white tracking-tight">
                LA-LA
              </span>
            </div>
          )}
          {isCollapsed && (
            <div className="w-8 h-8 rounded-lg bg-warm-500 flex items-center justify-center">
              <Hotel size={16} className="text-white" />
            </div>
          )}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className={`p-1.5 rounded-md text-brand-200 hover:text-white hover:bg-brand-600 transition-colors ${isCollapsed ? "hidden md:block absolute -right-3 top-5 bg-brand-700 border border-brand-500 shadow-lg z-10 rounded-full p-1" : ""}`}
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isCollapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {!isCollapsed && (
            <p className="text-[11px] font-semibold text-brand-300/70 uppercase tracking-wider px-3 mb-3">
              Navigation
            </p>
          )}
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                title={isCollapsed ? item.label : undefined}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 ${active
                    ? "bg-white/15 text-white"
                    : "text-brand-200 hover:text-white hover:bg-white/8"
                  }`}
              >
                <Icon size={18} className={active ? "text-warm-400" : "text-brand-300"} />
                {!isCollapsed && <span>{item.label}</span>}
                {active && !isCollapsed && (
                  <div className="ml-auto w-1.5 h-1.5 rounded-full bg-warm-400" />
                )}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-3 border-t border-brand-600/50">
          <button
            onClick={() => setShowLogoutModal(true)} // 👈 open modal instead of logout directly
            className={`w-full flex items-center ${isCollapsed ? "justify-center" : ""} gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium text-brand-200 hover:text-red-300 hover:bg-red-500/15 transition-colors`}
          >
            <LogOut size={18} />
            {!isCollapsed && "Log out"}
          </button>
        </div>
      </aside>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-6 w-[320px] text-center">

            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="bg-red-100 p-3 rounded-full">
                <AlertTriangle className="text-red-500" size={28} />
              </div>
            </div>

            {/* Text */}
            <h3 className="text-lg font-semibold text-gray-800">
              Confirm Logout
            </h3>
            <p className="text-sm text-gray-500 mt-2">
              Are you sure you want to log out?
            </p>

            {/* Buttons */}
            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="flex-1 border border-gray-300 rounded-lg py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleLogoutConfirm}
                className="flex-1 bg-red-500 text-white rounded-lg py-2 text-sm hover:bg-red-600 transition-colors"
              >
                Yes, Log out
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;















































// import React, { useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import {
//   LayoutDashboard,
//   Hotel,
//   Users,
//   CalendarCheck,
//   LogOut,
//   ChevronLeft,
//   ChevronRight,
//   Clock,
// } from "lucide-react";
// import { logout } from "../utils/auth";

// const Sidebar: React.FC = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const navItems = [
//     { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
//     { path: "/hotels", label: "Hotels", icon: Hotel },
//     { path: "/owner-listings", label: "Owner Listing", icon: Users },
//     // { path: "/pending-listings", label: "Pending Review", icon: Clock },
//     { path: "/customers", label: "Customers", icon: Users },
//     // { path: "/bookings", label: "Bookings", icon: CalendarCheck },
//   ];

//   const isActive = (path: string) => location.pathname === path;

//   return (
//     <aside
//       className={`${isCollapsed ? "w-[72px]" : "w-64"
//         } bg-brand-700 h-screen transition-all duration-300 flex flex-col`}
//     >
//       {/* Logo Header */}
//       <div className={`flex items-center ${isCollapsed ? "justify-center" : "justify-between"} h-16 px-4 border-b border-brand-600/50`}>
//         {!isCollapsed && (
//           <div className="flex items-center gap-2.5">
//             <div className="w-8 h-8 rounded-lg bg-warm-500 flex items-center justify-center">
//               <Hotel size={16} className="text-white" />
//             </div>
//             <span className="text-base font-bold text-white tracking-tight">
//               HotelTZ
//             </span>
//           </div>
//         )}
//         {isCollapsed && (
//           <div className="w-8 h-8 rounded-lg bg-warm-500 flex items-center justify-center">
//             <Hotel size={16} className="text-white" />
//           </div>
//         )}
//         <button
//           onClick={() => setIsCollapsed(!isCollapsed)}
//           className={`p-1.5 rounded-md text-brand-200 hover:text-white hover:bg-brand-600 transition-colors ${isCollapsed ? "hidden md:block absolute -right-3 top-5 bg-brand-700 border border-brand-500 shadow-lg z-10 rounded-full p-1" : ""}`}
//           aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//         >
//           {isCollapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
//         </button>
//       </div>

//       {/* Navigation */}
//       <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
//         {!isCollapsed && (
//           <p className="text-[11px] font-semibold text-brand-300/70 uppercase tracking-wider px-3 mb-3">
//             Navigation
//           </p>
//         )}
//         {navItems.map((item) => {
//           const Icon = item.icon;
//           const active = isActive(item.path);
//           return (
//             <Link
//               key={item.path}
//               to={item.path}
//               title={isCollapsed ? item.label : undefined}
//               className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 ${active
//                   ? "bg-white/15 text-white"
//                   : "text-brand-200 hover:text-white hover:bg-white/8"
//                 }`}
//             >
//               <Icon size={18} className={active ? "text-warm-400" : "text-brand-300"} />
//               {!isCollapsed && <span>{item.label}</span>}
//               {active && !isCollapsed && (
//                 <div className="ml-auto w-1.5 h-1.5 rounded-full bg-warm-400" />
//               )}
//             </Link>
//           );
//         })}
//       </nav>

//       {/* Footer */}
//       <div className="p-3 border-t border-brand-600/50">
//         <button
//           onClick={() => {
//             logout();
//             navigate("/login");
//           }}
//           className={`w-full flex items-center ${isCollapsed ? "justify-center" : ""} gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium text-brand-200 hover:text-red-300 hover:bg-red-500/15 transition-colors`}
//         >
//           <LogOut size={18} />
//           {!isCollapsed && "Log out"}
//         </button>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;
